/**
 * Source-verification enum labels (F6-6).
 *
 * Single source of truth for these literal values is docs/data-dictionary.md
 * (来源核对枚举) — mirrored from server/veridoc_verify/constants.py. The Chinese
 * labels match docs/glossary.md / the data dictionary so the UI never invents
 * its own wording. Do NOT hardcode these strings at call sites
 * (rules/common/coding-style.md).
 */
import type {
  VerdictConsistency,
  VerdictExistence,
  VerdictOverall,
  VerdictValidity,
} from '../../lib/veridoc-api';

/** Composite-status display labels (verdict.overall). */
export const OVERALL_LABELS: Record<VerdictOverall, string> = {
  pass: '通过',
  warning: '警示',
  fail: '不通过',
  unverifiable: '无法核验',
};

/** Sort rank — most actionable first (fail → warning → unverifiable → pass). */
export const OVERALL_SEVERITY: Record<VerdictOverall, number> = {
  fail: 0,
  warning: 1,
  unverifiable: 2,
  pass: 3,
};

/** V1 存在性. */
export const EXISTENCE_LABELS: Record<VerdictExistence, string> = {
  existing: '存在',
  'not-found': '不存在',
  unverifiable: '无法核验',
};

/** V2 现行有效性. */
export const VALIDITY_LABELS: Record<VerdictValidity, string> = {
  'in-force': '现行有效',
  repealed: '已废止',
  amended: '已修改',
  unknown: '时效未知',
  'n/a': '不适用',
};

/** V3 内容一致性. */
export const CONSISTENCY_LABELS: Record<VerdictConsistency, string> = {
  consistent: '一致',
  questionable: '存疑',
  inconsistent: '不一致',
  'not-evaluated': '未评',
};

/** Dimension display names (PRD §4 V1/V2/V3). */
export const DIMENSION_LABELS = {
  existence: '存在性',
  validity: '现行有效性',
  consistency: '内容一致性',
} as const;
